<template>
  <div class="chart_container_cla">
    <div class="card_cla">
      <div class="container_header"
           v-bind:style="{ 'background-color': getTheme}">
        <div class="title_cla">{{title}}</div>
        <div class="head_solt">
          <slot name="header"></slot>
        </div>
      </div>
      <div class="container_body">
        <slot></slot>
        <div style="clear: both;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      getTheme: 'getTheme'
    })
  },
  props: {
    title: {
      type: String,
      default: 'title'
    }
  },
  mounted () { },
  methods: {}
}
</script>

<style scoped lang="less">
@titleHeight: 40px;
.chart_container_cla {
  width: 50%;
  padding: 10px;
  float: left;
  position: relative;
  box-sizing: border-box;
  .card_cla {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border: 1px solid #ebeef5;
    overflow: hidden;
    .container_header {
      position: relative;
      z-index: 500;
      height: @titleHeight;
      line-height: @titleHeight;
      color: #fff;
      background-color: black;
      .title_cla {
        padding-left: 20px;
        float: left;
        line-height: @titleHeight;
        height: @titleHeight;
      }
      .head_solt {
        float: right;
        padding-right: 10px;
        z-index: 1000;
      }
    }
    .container_body {
      z-index: 1000;
      min-height: 100px;
      padding: 10px;
      box-sizing: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/comComponent/chartContainer.vue